module.exports = {
        srcSet: __webpack_public_path__ + "static/media/MagentaTvBannerDesktop-800.e86c5620.webp"+" 800w"+","+__webpack_public_path__ + "static/media/MagentaTvBannerDesktop-1000.fa171972.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "static/media/MagentaTvBannerDesktop-800.e86c5620.webp",width: 800,height: 255},{path: __webpack_public_path__ + "static/media/MagentaTvBannerDesktop-1000.fa171972.webp",width: 1000,height: 319}],
        src: __webpack_public_path__ + "static/media/MagentaTvBannerDesktop-1000.fa171972.webp",
        toString: function(){return __webpack_public_path__ + "static/media/MagentaTvBannerDesktop-1000.fa171972.webp"},
        
        width: 1000,
        height: 319
      }